import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Truck, Users, Package, Container, Building2, Mail, FileText, MessageSquare, Settings, Boxes, LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/shipments", label: "Shipments", icon: Package },
  { to: "/admin/drivers", label: "Drivers", icon: Users },
  { to: "/admin/trucks", label: "Trucks", icon: Truck },
  { to: "/admin/trailers", label: "Trailers", icon: Container },
  { to: "/admin/customers", label: "Customers", icon: Building2 },
  { to: "/admin/quotes", label: "Quote Requests", icon: FileText },
  { to: "/admin/applications", label: "Applications", icon: Users },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/content", label: "Content", icon: Boxes },
  { to: "/admin/company", label: "Company Info", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[var(--lt-bg)] text-[color:var(--lt-text)] flex" data-testid="admin-dispatch-dashboard">
      <aside data-lt-scheme="dark" className="hidden lg:flex w-64 flex-col border-r border-[var(--lt-border)] bg-[#0A0C0F] sticky top-0 h-screen">
        <div className="p-5 border-b border-[var(--lt-border)] bg-white/95 rounded-b" data-lt-scheme="light"><Link to="/"><Logo size="sm" /></Link></div>
        <nav className="flex-1 p-3 space-y-1 overflow-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-xs font-head uppercase tracking-widest transition-colors ${isActive ? "bg-[var(--lt-accent)] text-white" : "text-slate-400 hover:bg-[var(--lt-panel)] hover:text-white"}`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[var(--lt-border)]">
          <div className="text-xs text-slate-500 px-3 mb-2 truncate">{user?.email}</div>
          <Button onClick={doLogout} variant="ghost" data-testid="admin-logout" className="w-full justify-start text-slate-400 hover:text-white hover:bg-[var(--lt-panel)] rounded-xl h-10 text-xs font-head uppercase tracking-widest"><LogOut className="h-4 w-4 mr-2" /> Sign Out</Button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="lg:hidden border-b border-[var(--lt-border)] p-4 flex items-center justify-between">
          <Logo size="sm" />
          <Button onClick={doLogout} variant="ghost" size="sm" className="text-slate-400"><LogOut className="h-4 w-4" /></Button>
        </header>
        <div className="p-6 md:p-10 max-w-7xl">
          <Outlet />
        </div>
      </div>
      <Toaster theme={theme} />
    </div>
  );
}
